/**
 * Solio Waitlist Modal — site-wide.
 *
 * Triggers: any element with [data-waitlist-trigger]
 * - Opens modal, focuses first focusable, traps focus while open.
 * - ESC closes. Clicking the backdrop closes. The × button closes.
 * - Returns focus to the triggering element on close.
 *
 * Form submission:
 * - Intercepts submit, POSTs FormData to /contact via fetch()
 * - Optimistic success: any 2xx (or opaque) response swaps form for success
 * - On error: re-enables submit, leaves form intact (user can retry)
 */
(function () {
  'use strict';

  var modal       = document.querySelector('[data-solio-waitlist-modal]');
  if (!modal) return;

  var backdrop    = modal.querySelector('[data-waitlist-backdrop]');
  var closeBtn    = modal.querySelector('[data-waitlist-close]');
  var form        = modal.querySelector('[data-waitlist-form]');
  var successEl   = modal.querySelector('[data-waitlist-success]');
  var submitBtn   = form ? form.querySelector('button[type="submit"]') : null;

  var lastTrigger = null;

  /* ---- focus trap helpers ---- */
  function focusableElements() {
    return Array.prototype.slice.call(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      // Skip hidden form/success block
      return el.offsetParent !== null;
    });
  }

  function trap(e) {
    if (e.key !== 'Tab') return;
    var f = focusableElements();
    if (f.length === 0) return;
    var first = f[0];
    var last  = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      close();
    } else {
      trap(e);
    }
  }

  /* ---- open / close ---- */
  /* Customer tags: the trigger's own data-waitlist-tags, else the batch
     counter's ("solio-waitlist,waitlist-charge-09"), else the form default. */
  var tagsInput   = form ? form.querySelector('input[name="contact[tags]"]') : null;
  var defaultTags = tagsInput ? tagsInput.value : '';

  function open(trigger) {
    lastTrigger = trigger || document.activeElement;
    if (tagsInput) {
      var batch = document.querySelector('[data-batch-counter][data-waitlist-tags]');
      var tags = (trigger && trigger.getAttribute && trigger.getAttribute('data-waitlist-tags')) ||
                 (batch && batch.getAttribute('data-waitlist-tags'));
      tagsInput.value = tags || defaultTags;
    }
    modal.setAttribute('aria-hidden', 'false');
    modal.removeAttribute('hidden');
    document.body.classList.add('solio-modal-open');
    document.addEventListener('keydown', onKeydown);
    // Defer focus until paint
    requestAnimationFrame(function () {
      var f = focusableElements();
      // Prefer the email input over the close × on open
      var input = form ? form.querySelector('input[type="email"]') : null;
      (input || f[0]).focus();
    });
  }

  function close() {
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('hidden', '');
    document.body.classList.remove('solio-modal-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  /* ---- wire global triggers ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-waitlist-trigger]');
    if (t) {
      e.preventDefault();
      open(t);
    }
  });

  if (backdrop) backdrop.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);

  /* ---- form submit (AJAX → /contact) ---- */
  if (form && successEl) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn) submitBtn.disabled = true;

      var data = new FormData(form);
      fetch((function () { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; return (r !== '/' && window.location.pathname.indexOf(r) === 0) ? r : '/'; })() + 'contact', {
        method: 'POST',
        body: data,
        // Shopify's /contact returns a full HTML page; we just need 2xx/opaque.
        mode: 'no-cors',
        credentials: 'same-origin'
      }).then(function () {
        // Optimistic success — show confirmation.
        form.setAttribute('hidden', '');
        successEl.removeAttribute('hidden');
      }).catch(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
    });
  }
})();
